import { render, staticRenderFns } from "./userWalletCash.vue?vue&type=template&id=38b3b2f0&scoped=true&"
import script from "./userWalletCash.vue?vue&type=script&lang=js&"
export * from "./userWalletCash.vue?vue&type=script&lang=js&"
import style0 from "./userWalletCash.vue?vue&type=style&index=0&id=38b3b2f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b3b2f0",
  null
  
)

export default component.exports